import { render } from "./Minister.vue?vue&type=template&id=14fd408e&scoped=true&ts=true"
import script from "./Minister.ts?vue&type=script&lang=ts"
export * from "./Minister.ts?vue&type=script&lang=ts"

import "./Minister.scss?vue&type=style&index=0&id=14fd408e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fd408e"]])

export default __exports__